<template>
    <div class="w-full flex flex-col p-8 text-ternary">
        <div v-if="(role == 'admin' || role == 'superadmin') && item.partner" class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Employer</div>
            <div class="w-3/4">{{ item.partner.en_company_name }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Title</div>
            <div class="w-3/4">{{ item.title }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Description</div>
            <div class="w-3/4">{{ item.description }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Trainer Information</div>
            <div class="w-3/4" v-html="item.trainer_information"></div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Start Date</div>
            <div class="w-3/4">{{ getFormattedDate(item.start_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">End Date</div>
            <div class="w-3/4">{{ getFormattedDate(item.end_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Location</div>
            <div class="w-3/4">{{ item.location }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Entity</div>
            <div class="w-3/4">{{ item.entity }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Duration</div>
            <div class="w-3/4">{{ item.duration }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Prerequisites</div>
            <div class="w-3/4">{{ item.prerequisites }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Additional Information</div>
            <div class="w-3/4">{{ item.additional_information }}</div>
        </div>
    </div>
</template>

<script>
import { formattedDate } from "../../helpers/utils";
export default {
    name: "view-post-training",
    props: ["item"],
    computed: {
        role() {
            return this.$store.getters.role;
        },
    },
    methods: {
        getFormattedDate(date) {
            return formattedDate(date);
        },
    },
}
</script>